// extracted by mini-css-extract-plugin
module.exports =  {"root":"_0d624b9a27--root--y9Z5p","desktop":"_0d624b9a27--desktop--IIri5","title":"_0d624b9a27--title--VmVLT","icon":"_0d624b9a27--icon--p6rJA"};